import { makeStyles } from '@material-ui/core/styles'

const BP960 = 960

const useStyles = makeStyles((theme) => {
  return ({
    root: {
      overflowX: 'hidden !important',
      minHeight: '300px',
      height: 'calc(100vh - 45px)', // minus header height
      maxHeight: '1400px',
      color: theme.palette.secondary.main,
      position: 'relative',
      [theme.breakpoints.up(BP960)]: {
        height: 'calc(100vh - 90px)', // minus header height
      },
    },
    videoWrapper: {
      background: 'rgba(0,0,0,.5)',
      zIndex: 1,
      width: '100%',
      minHeight: '300px',
      height: 'calc(100vh - 45px)', // minus header height
      maxHeight: '1400px',
      position: 'relative',
      [theme.breakpoints.up(BP960)]: {
        height: 'calc(100vh - 90px)', // minus header height
      },
    },
    sectionContainer: {
      overflowX: 'hidden',
      width: '100%',
      minHeight: '300px',
      height: 'calc(100vh - 45px)', // minus header height
      maxHeight: '1400px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: 0,
      padding: 0,
      [theme.breakpoints.up(BP960)]: {
        height: 'calc(100vh - 90px)', // minus header height
      },
    },
    slide: {
      width: '100%',
      minWidth: 344,
      height: '200px',
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      padding: '0 1.5rem',
      [theme.breakpoints.up('md')]: {
        padding: 0,
      },
    },
    slideContentContainer: {
      display: 'flex',
      flexDirection: 'column',
    },
    slideHeading: {
      ...theme.typography.h1,
      fontSize: '3rem !important',
      color: 'white !important',
      lineHeight: '55px',
      marginBottom: 7,
      [theme.breakpoints.up('md')]: {
        fontSize: '5rem !important',
        lineHeight: '86px',
      },
      [theme.breakpoints.down('md')]: {
        marginTop: 0,
      },
    },
    slidePreHeading: {
      ...theme.typography.overline,
      color: 'white',
      marginBottom: '24px',
      '@media(max-height: 750px)': {
        display: 'none',
      },
    },
    slideSubHeading: {
      ...theme.typography.h1,
      fontSize: '1.5rem !important',
      color: 'white !important',
      lineHeight: '40px',
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(3),
      [theme.breakpoints.up('md')]: {
        fontSize: '2rem !important',
        lineHeight: '40px',
      },
      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(2),
      },
      '@media(max-height: 750px)': {
        lineHeight: '2rem',
        marginBottom: '10px',
      },
    },
    iconLongArrow: {
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
      '@media(max-height: 750px)': {
        display: 'none',
      },
    },
    halfCircle: {
      width: '134px',
      height: '134px',
      position: 'absolute',
      bottom: '-85px',
      left: '50%',
      borderRadius: '50%',
      background: '#fff',
      marginLeft: '-67px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 0,
      [theme.breakpoints.down('xs')]: {
        width: 100,
        height: 100,
        bottom: '-70px',
        marginLeft: '-50px',
      },
    },
    halfCircleArrow: {
      marginTop: '-80px',
      fontSize: '1.25rem',
      color: theme.palette.primary.dark,
      [theme.breakpoints.down('xs')]: {
        fontSize: '1rem',
        marginTop: '-65px',
      },
    },
    bgImagesContainer: {
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      position: 'absolute',
      zIndex: -1,
      '&:after': {
        content: '""',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        position: 'absolute',
        background: 'rgba(0,0,0,.5)',
      },
    },
    bgImageContainer: {
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      position: 'absolute',
      zIndex: -1,
    },
    fvcBgImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      opacity: 0,
      transition: 'all 1s ease',
    },
    fvcBgImage_selected: {
      opacity: '1 !important',
    },
    skipLink: {
      ...theme.typography.subtitle2,
      position: 'absolute',
      bottom: 6,
      right: -2,
      fontSize: 11,
      color: 'white !important',
      [theme.breakpoints.up(BP960)]: {
        bottom: 14,
        right: 14,
        fontSize: 14,
      },
    },
    slideButtonCTA: {
      marginTop: 17,
      backgroundColor: theme.palette.gold.main,
      '&:focus': {
        outline: '2px solid white',
        border: '1px solid black',
      },
      [theme.breakpoints.down('xs')]: {
        '@media(max-height: 750px)': {
          marginTop: '0px',
          marginBottom: '5px',
        },
      },
    },
    videoContainer: {
      position: 'absolute',
      zIndex: -2,
      top: 0,
      objectFit: 'cover',
      width: '100%',
      height: '100%',
    },
    videoOverlay: {
      content: "''",
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      background: 'rgba(0,0,0,.5)',
      zIndex: -1,
    },
    buttonContainer: {
      position: 'absolute',
      left: 14,
      bottom: 14,
      display: 'flex',
      [theme.breakpoints.up(BP960)]: {
        bottom: 20,
      },
      '&>button:nth-child(1)': {
        marginRight: theme.spacing(1),
        paddingLeft: '10px',
      },
    },
    videoButton: {
      ...theme.typography.navigation,
      display: 'flex',
      background: 'transparent',
      border: 'none',
      fontSize: '18px',
      color: 'white !important',
      alignItems: 'center',
      '&:hover': {
        cursor: 'pointer',
      },
    },
    videoButtonIcon: {
      width: 24,
      height: 24,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'white',
      borderRadius: '100rem',
      marginRight: 10,
      boxShadow: theme.palette.shadow.cardBoxShadow,
      '& svg': {
        height: 17,
      },
    },
    videoButtonLabel: {
      fontSize: 14,
    },
    playButton: {
      '&>div>svg': {
        marginLeft: '3px',
      },
    },
    ctaBoxWrapper: {
      [theme.breakpoints.down('xs')]: {
        marginTop: theme.spacing(8),
        '@media(max-height: 750px)': {
          marginTop: theme.spacing(4),
          '&>div>div': {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(1),
            '&>div>h2': {
              fontSize: '0.9rem !important',
            },
            '&>a>span': {
              fontSize: '0.8rem !important',
            },
          },
        },
        '@media(max-height: 650px)': {
          display: 'none',
        },
      },
      marginTop: theme.spacing(10),
      '@media(max-height: 610px)': {
        display: 'none',
      },

      [theme.breakpoints.up('lg')]: {
        marginTop: theme.spacing(18),
        '@media(max-height: 900px)': {
          marginTop: theme.spacing(10),
        },
      },
    },
  })
})

export default useStyles
